import { createFileRoute } from '@tanstack/react-router'
import Ekip from '@/modules/ekip'

export const Route = createFileRoute('/_authenticated/ekip/')({
  component: Ekip,
})
